import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import RendersIcons from '../componets/RednersIcons'
import { styled } from '@mui/material/styles';


const CustomListItemText = styled(ListItemText)(({ theme }) => ({
        '& .MuiTypography-root': {
            width: '86%'
        }
}));

export default function RenderPage(props) {
    const [menujson, setMenujson] = useState(props.menujson.data);
    const renderList = (title, keyTitle) => {
        let keyTitle2 = keyTitle
        var dishe = title.dishe
        return dishe.map((value, key) =>

            <ListItem key={key}
                secondaryAction={
                    <div id="buttons">
                        <IconButton onClick={() => priceOnclick(keyTitle2, key)}>
                            <ListItemText
                                primary={value.price + "€"}
                            />
                        </IconButton>
                        {renderButtonQuantity(value, keyTitle2, key)}
                    </div>
                }
            >
                <ListItemAvatar>
                    <RendersIcons title={title.title} />
                </ListItemAvatar>
                <CustomListItemText
                    color="#16314c"
                    primary={value.name}
                    secondary={value.description}
                />
            </ListItem>,
        );
    }

    const quantityOnclick = (titleKey, valueKey) => {
        let json = [...menujson];
        var price = json[titleKey].dishe[valueKey].price;
        var name = json[titleKey].dishe[valueKey].name;
        var title = json[titleKey].title
        if (json[titleKey].dishe[valueKey].quantity == null || json[titleKey].dishe[valueKey].quantity == 0) {
            json[titleKey].dishe[valueKey].quantity = 0
        } else {
            --json[titleKey].dishe[valueKey].quantity
        }
        if (json[titleKey].dishe[valueKey].quantity != null && json[titleKey].dishe[valueKey].quantity == 0) {
            props.cart.delete(name)
        }
        props.cart.set(name, {
            quantity: json[titleKey].dishe[valueKey].quantity,
            price: price,
            title: title
        })
        setMenujson(json)

    }

    const renderButtonQuantity = (value, titleKey, valueKey) => {
        return (<IconButton color={value.quantity != null && value.quantity != 0 ? "warning" : "success"}
            onClick={() => quantityOnclick(titleKey, valueKey)}
        >
            <ListItemText
                primary={value.quantity != null ? value.quantity : 0}
            />
        </IconButton>
        );
    }

    const priceOnclick = (titleKey, valueKey) => {
        let json = [...menujson];
        var price = json[titleKey].dishe[valueKey].price;
        var name = json[titleKey].dishe[valueKey].name;
        var title = json[titleKey].title

        if (json[titleKey].dishe[valueKey].quantity == null) {
            json[titleKey].dishe[valueKey].quantity = 1
        } else {
            ++json[titleKey].dishe[valueKey].quantity
        }
        props.cart.set(name, {
            quantity: json[titleKey].dishe[valueKey].quantity,
            price: price,
            title: title
        })
        // this.setState({
        //     menujson: this.state.menujson,
        // });
        setMenujson(json)
    }

    return (menujson.map((value, key) =>
        <div className="Content-list" key={key}>
            <Typography
                variant="h5"
                component="div"
                align="center"
                color="#16314c">
                {value.title}
            </Typography>
            {renderList(value, key)}
        </div>
    ));
}